import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object } from "yup";
import PURCHASEIRQCreditScoreView from "../views/IrqCreditScoreView";
import { validationMap } from "../validations/validationMap";
import StatusCheck from "../components/StatusCheck";

class BuildIrqCreditScorePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={validationMap.BuildIrqCreditScorePage}
        >
          <PURCHASEIRQCreditScoreView
            content={contentMap.BuildIrqCreditScorePage}
            navigationsAway={customNavigationMap.BuildIrqCreditScorePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(BuildIrqCreditScorePage);
